import { Stack, Typography } from '@mui/material';
import { PartialRestoreType } from '@repo/api-gw-sdk';
import type { RestoreJob } from '@repo/api-gw-sdk';

import { PathLink } from '@/components/explorer/fileLink';
import { useDAL } from '@/contexts/useDAL';

export const PartialRestoreDataField = ({ entity }: { entity: RestoreJob }) => {
  const resourceId = entity.resourceDetails?.id;
  if (!resourceId) {
    return null;
  }
  return (
    <PartialRestoreDataFieldInner entity={entity} resourceId={resourceId} />
  );
};

const PartialRestoreDataFieldInner = ({
  entity,
  resourceId,
}: {
  entity: RestoreJob;
  resourceId: string;
}) => {
  const dal = useDAL();
  const { data: body } = dal.inventory.useResource(resourceId || '');

  if (
    entity.partialRestoreData?.partialRestoreType ===
    PartialRestoreType.FilesPartialRestoreData
  ) {
    if (!body?.resource) {
      return null;
    }
    return (
      entity.partialRestoreData?.files?.files.length && (
        <Stack gap='8px'>
          {entity.partialRestoreData?.files?.files.map((file) => (
            <PathLink
              key={file.path}
              entity={body?.resource}
              path={file.path}
              pathType={file.pathType}
            />
          ))}
        </Stack>
      )
    );
  } else {
    const id =
      entity.partialRestoreData?.awsEbsVolume?.providerVolumeId ||
      entity.partialRestoreData?.azureDisk?.diskId ||
      entity.partialRestoreData?.gcpDisk?.diskId;
    return id && <Typography>{id}</Typography>;
  }
};
